import React, { useRef } from "react";
import {
  translate,
  translateNumber,
  translateWithValues,
} from "../../localization/TranslationUtil";
import TextCaption from "../../components/TextCaption/TextCaption";
import "./FourthSlideAnimalWelfare.scss";
import ReferenceValueChart from "../../components/ReferenceValueChart/ReferenceValueChart";
import {
  SUSTAINABILITY_CHART_FOR_ADULTS_RANGE_MAX_COLOR,
  SUSTAINABILITY_CHART_FOR_ADULTS_RANGE_MID_COLOR,
  SUSTAINABILITY_CHART_FOR_ADULTS_RANGE_MIN_COLOR,
  SUSTAINABILITY_CHART_FOR_ADULTS_STROKE_WIDTH,
} from "../../common/constants";
import { translateDynamic } from "../../localization/TranslationUtil";
import useWindowDimensions from "../../hooks/useViewportDimensions";

const FourthSlideAnimalWelfare = ({ farmDetails }) => {
  //#region initialize viewport width value in order to be able to calculate properly the size of the sustainability diagram
  let { width: VIEWPORT_WIDTH_IN_PX, height: VIEWPORT_HEIGHT_IN_PX } =
    useWindowDimensions();
  const viewportWidthInPxRef = useRef(VIEWPORT_WIDTH_IN_PX);
  const viewportHeightInPxRef = useRef(VIEWPORT_HEIGHT_IN_PX);
  let isAppOpenedInLandscapeMode = VIEWPORT_WIDTH_IN_PX > VIEWPORT_HEIGHT_IN_PX;
  VIEWPORT_WIDTH_IN_PX = isAppOpenedInLandscapeMode
    ? VIEWPORT_WIDTH_IN_PX
    : VIEWPORT_HEIGHT_IN_PX;
  VIEWPORT_HEIGHT_IN_PX = isAppOpenedInLandscapeMode
    ? VIEWPORT_HEIGHT_IN_PX
    : VIEWPORT_WIDTH_IN_PX;
  viewportWidthInPxRef.current = VIEWPORT_WIDTH_IN_PX;
  viewportHeightInPxRef.current = VIEWPORT_HEIGHT_IN_PX;
  const diagramContainerWidthInPixels = 0.2 * viewportWidthInPxRef.current;
  const diagramRadiusInPixels = (1 / 3) * diagramContainerWidthInPixels;
  const diagramStrokeSizeInPixels = 0.02 * diagramContainerWidthInPixels;
  //#endregion

  const farmerName = translateDynamic(farmDetails?.farmer?.name);
  const farmName = translateDynamic(farmDetails?.farmName);
  const grazingStory = translateDynamic(
    farmDetails?.animalWelfare?.grazingStory,
  );

  return (
    <div className="animalWelfareStoryFourthSlide">
      <ReferenceValueChart
        currentValue={(farmDetails?.animalWelfare?.grazingDays)}
        referenceValue={translateNumber(
          "GRAZING_DAYS_DIAGRAM_RANGE_REFERENCE",
        )}
        rangeMaxValue={translateNumber(
          "GRAZING_DAYS_DIAGRAM_RANGE_MAX",
        )}
        rangeMinValue={translateNumber(
          "GRAZING_DAYS_DIAGRAM_RANGE_MIN",
        )}
        rangeMinColor={SUSTAINABILITY_CHART_FOR_ADULTS_RANGE_MIN_COLOR}
        rangeMidColor={SUSTAINABILITY_CHART_FOR_ADULTS_RANGE_MID_COLOR}
        rangeMaxColor={SUSTAINABILITY_CHART_FOR_ADULTS_RANGE_MAX_COLOR}
        unitText={translate(
          "GRAZING_DAYS_DIAGRAM_RANGE_UNIT",
        )}
        labelText={translate(
          "GRAZING_DAYS_DIAGRAM_RANGE_LABEL",
        )}
        referenceLabelText={translate("SUSTAINABILITY_AVG_FARM_TEXT")}
        currentLabelText={farmName}
        diagramContainerWidthInPixels={diagramContainerWidthInPixels}
        diagramContainerHeightInPixels={diagramContainerWidthInPixels}
        diagramRadiusInPixels={diagramRadiusInPixels}
        gradientMeterStrokeWidthInPixels={diagramStrokeSizeInPixels}
        cssClassname={"grazingDaysForMilkChart"}
      />
      <TextCaption additionalCssClassname="animalWelfareStoryFourthSlide--textCaption">
        <div className="animalWelfareStoryFourthSlide-title">
          {translate("ANIMAL_WELFARE_GRAZING_TITLE")}
        </div>
        <div className="animalWelfareStoryFourthSlide--text">
          {translate("ANIMAL_WELFARE_GRAZING_TЕXT")}
        </div>
        {grazingStory ? (
          <div>
            <div className="animalWelfareStoryFourthSlide-farmer-title">
              {translateWithValues("SUSTAINABILITY_FARMER_NAME_TITLE", {
                farmerName,
              })}
            </div>
            <div className="animalWelfareStoryFourthSlideFarmer--text">
              {grazingStory}
            </div>
            <a
          className="animalWelfareStoryFourthSlide--link"
          href="https://www.cbs.nl/nl-nl/nieuws/2022/31/meer-koeien-in-de-wei-maar-wel-korter#:~:text=Het%20weideseizoen%20loopt%2C%20afhankelijk%20van,naar%20155%20dagen%20in%202021."
          target="_blank"
        >
          {translate("ANIMAL_WELFARE_SOURCE_LINK")}
        </a>
          </div>
        ) : null}
      </TextCaption>
      <div className="sustainabilityStory-treeAndSmallBush"></div>
    </div>
  );
};

export default FourthSlideAnimalWelfare;
